export { default } from "./geometryLabel";
